import _ from 'lodash'
import Backbone from 'backbone'
import template from './new-sql-console.hbs'
import FormView from 'scoreboard/components/form-view'
import TextArea from 'scoreboard/components/textarea'

var NewSqlConsoleView = Backbone.View.extend({

	tagName: 'form',

	className: 'reports sql-console',

	initialize: function(options) {
		this.formView = new FormView({el: this.el})

		this.listenTo(this.formView, 'change', function() {
			this.model.set('query', this.$('.query').val())
		}.bind(this))
	},

	render: function() {
		this.$el.html(template(this.model.attributes))
		this.formView.start()
		this.queryTexarea = new TextArea({ el: this.$('textarea.query') }).render()
		return this
	},

	remove: function() {
		Backbone.View.prototype.render.apply(this, this.arguments)
		_.invokeMap([this.formView], 'remove')
	}

})

export default NewSqlConsoleView

NewSqlConsoleView.__filename__ = 'reports/wizard/sql-console/new-sql-console.js'
